export default __webpack_public_path__ + "static/media/takeapunt.46c54dd1.jpg";